module.exports = require('../_components/@alicd/next-switch/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/switch/index.js
// module id = 674
// module chunks = 0